function noop() {}

export { noop };
